import { FileAddOutlined, SearchOutlined } from '@ant-design/icons';

// icons
const icons = { FileAddOutlined, SearchOutlined };

const claims = {
  id: 'claims',
  title: 'Claims',
  type: 'group',
  children: [
    {
      id: 'submit-claim',
      title: 'Submit Claim',
      type: 'item',
      url: '/claims',
      icon: icons.FileAddOutlined
    },
    {
      id: 'track-claim',
      title: 'Track Claims',
      type: 'item',
      url: '/claims/track',
      icon: icons.SearchOutlined
    }
  ]
};

export default claims;
